// Renders a reading line. For tone languages (jyutping, numbered pinyin) each
// syllable is coloured by its tone digit, so the tone is something you see at
// a glance rather than a digit you have to read.

export const CANTONESE_TONES: { n: number; name: string; contour: string }[] = [
  { n: 1, name: 'high level', contour: '55' },
  { n: 2, name: 'high rising', contour: '35' },
  { n: 3, name: 'mid level', contour: '33' },
  { n: 4, name: 'low falling', contour: '21' },
  { n: 5, name: 'low rising', contour: '23' },
  { n: 6, name: 'low level', contour: '22' },
];

const SYLLABLE = /([a-zü]+)([1-6])/gi;

export function Reading({ text, tones, class: cls = '' }: { text: string; tones: boolean; class?: string }) {
  if (!tones) return <span class={`reading ${cls}`}>{text}</span>;
  const parts: (string | { syl: string; tone: string })[] = [];
  let last = 0;
  for (const m of text.matchAll(SYLLABLE)) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push({ syl: m[1], tone: m[2] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return (
    <span class={`reading ${cls}`}>
      {parts.map((p, i) =>
        typeof p === 'string' ? (
          <span key={i}>{p}</span>
        ) : (
          <span key={i} class={`tone tone-${p.tone}`}>
            {p.syl}
            <sup>{p.tone}</sup>
          </span>
        ),
      )}
    </span>
  );
}
